
import * as z from "zod";

export const reportFormSchema = z.object({
  fullName: z.string().min(2, {
    message: "Full name must be at least 2 characters.",
  }),
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
  companyName: z.string().min(1, {
    message: "Company name is required.",
  }),
  jobTitle: z.string().min(1, {
    message: "Job title is required.",
  }),
  primaryInterest: z.string({
    required_error: "Please select your primary interest.",
  }),
  challenge: z.string().max(500, {
    message: "Your response must not exceed 500 characters.",
  }).optional(),
  consent: z.literal(true, {
    errorMap: () => ({ message: "You must accept the terms to continue." }),
  }),
});

export type ReportFormData = z.infer<typeof reportFormSchema>;

export const interestOptions = [
  { value: "Case Management AI", label: "Case Management AI" },
  { value: "Contract Analysis", label: "Contract Analysis" },
  { value: "Compliance Automation", label: "Compliance Automation" },
  { value: "Other", label: "Other" },
];
